module.exports = __webpack_public_path__ + "static/media/Vector5.aa7dff88.svg";